import React from "react";
import {SelectField} from "react-fields";

export default function Paginate(props) {

    const gotToPage = (e, page) => {
        e.preventDefault();
        props.gotToPage(page);
    };

    const firstPage = props.page <= 2 ? 1 : props.page >= props.totalPages ? props.page -2 : props.page - 1;

    return(
        <div>
            <div className="grid-x page-counter">
                <label className={'per-page-select'}>
                    <SelectField name="per_page"
                                 className={'label-icon-right select-label'}
                                 onChange={props.onChangePerPage}
                                 options={[10,25,50,100]}
                                 selected={props.perPage}
                    />
                </label>
                <div className={'page-counter--counter'}>
                    <span className="current">{props.count}</span> of {props.totalCount}
                </div>

            </div>
            <div className="grid-x flex-center">
                <nav className="users__pagination" aria-label="Pagination">
                    <ul className="pagination text-center">
                        {props.page > 1 ?
                        <li className="pagination-previous">
                            <a onClick={(e) => gotToPage(e, props.page -1)}/>
                        </li> : null}
                        {[firstPage, firstPage + 1, firstPage +2].map((page) => {
                            if (page > props.totalPages) {
                                return null;
                            }
                            return (
                                <li className={props.page === page ? "current" : ""} key={page}>
                                    <a onClick={(e) => gotToPage(e, page)}>{page}</a>
                                </li>
                            )
                        })}
                        {props.page < props.totalPages ?
                            <li className="pagination-next">
                                <a onClick={(e) => gotToPage(e, props.page + 1)}/>
                            </li> : null}
                    </ul>
                </nav>
            </div>
        </div>
    )

}